import type { AppDispatch, RootState } from '@/redux/store';
import { getConfiguration } from './configuration.thunks';

export const UNKNOWN_MINERVA_VERSION = '0.0.0';

/**
 * Returns the minerva version, fetching the configuration first if it is not in the store yet.
 * The admin panel does not fetch the configuration on start, but plugins may check the version
 * as soon as they are loaded.
 */
export const ensureMinervaVersion = async (
  dispatch: AppDispatch,
  getState: () => RootState,
): Promise<string> => {
  if (!getState().configuration.main.data) {
    await dispatch(getConfiguration());
  }

  return getState().configuration.main.data?.version ?? UNKNOWN_MINERVA_VERSION;
};
